import { Component, Input, OnInit } from '@angular/core';

import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-html-text-list',
    templateUrl: './html-text-list.component.html',
    styleUrls: ['./html-text-list.component.scss']
})
export class HtmlTextListComponent implements OnInit {
    
    @Input() items: WebItem[];

    constructor() { }

    ngOnInit() { }

}
